import { createFileRoute, redirect } from '@tanstack/react-router';

import { shouldShowWebOnboarding } from '@/features/onboarding-web';
import { getPostAuthLandingRoute } from '@/features/welcome';
import { queryClient } from '@/query/client';
import { userQueryOptions } from '@/query/user';
import { userStore } from '@/stores/user.store';
import { AppCapability, isCapable } from '@/utils/capabilities';

export const Route = createFileRoute('/onboarding')({
  staticData: { requiresAuth: true },
  beforeLoad: async ({ context, location }) => {
    await context.auth.requireAuth(location);
  },

  async loader() {
    if (!userStore.user) {
      const user = await queryClient.ensureQueryData(userQueryOptions());
      if (user) userStore.setUser(user);
    }

    const showDesktopOnboarding =
      isCapable(AppCapability.Onboarding) && !userStore.isOnboarded;
    const showWebOnboarding = await shouldShowWebOnboarding();

    if (!showDesktopOnboarding && !showWebOnboarding) {
      throw redirect({
        to: getPostAuthLandingRoute() as string,
        replace: true,
      });
    }
  },
});
